export const inspectBoolean = (value) => value.toString()
